<div [ngClass]="{'compound-field': true, 'centered': layoutObject?.centered, 'parent-is-compound-field': parentIsCompoundField, 'align-elements': hasFieldsWithAlignment}">

  <!-- default paragraph layout -->
  @if (!hasFieldsWithAlignment) {
    @for (element of layoutObject?.elements; track trackByIndex($index, element); let last = $last; let first = $first) {
      <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
    }
  }

  <!-- paragraph layout with field alignment -->
  @if (hasFieldsWithAlignment) {
    <div #LeftElementWrapper class="lm-paragraph-element-wrapper left">
      <!-- elements that don't have an alignment directive are included in the elements array -->
      @for (element of layoutObject.elements; track trackByIndex($index, element); let last = $last; let first = $first) {
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      }
      @for (element of layoutObject.leftElements; track trackByIndex($index, element); let last = $last; let first = $first) {
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      }
    </div>

    <div #CenterElementWrapper class="lm-paragraph-element-wrapper center">
      @for (element of layoutObject.centerElements; track trackByIndex($index, element); let last = $last; let first = $first) {
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      }
    </div>

    <div #RightElementWrapper class="lm-paragraph-element-wrapper right">
      @for (element of layoutObject.rightElements; track trackByIndex($index, element); let last = $last; let first = $first) {
        <ng-container *ngTemplateOutlet="ParagraphElements; context: {element: element, last: last, first: first}"></ng-container>
      }
    </div>
  }

  <ng-template #ParagraphElements let-element=element let-last=last let-first=first>
    @switch (element.elementLayout) {

      @case (layoutSubType.CHECK_CONTROL) {
        <ng-template visiblewhen [layoutObject]="element.checkcontrol" [model]="model" [specFields]="specFields">
          @if (!element.checkcontrol.cfgHidden) {
            <lm-checkcontrol
                    #Element
                    [layoutObject]="element.checkcontrol"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [model]="model"
                    [layoutInfo]="layoutInfo"
                    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                    [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                    (fieldEvent)="onFieldEvent($event)"
                    class="field"
            ></lm-checkcontrol>
          }
        </ng-template>
      }

      @case (layoutSubType.CAPTCHA_CONTROL) {
        <ng-template visiblewhen [layoutObject]="element.captchaControl" [model]="model" [specFields]="specFields">
          <lm-captcha-control [layoutObject]="element.captchaControl" [parentIsParagraph]="true"></lm-captcha-control>
        </ng-template>
      }

      @case (layoutSubType.BUTTON) {
        <ng-template visiblewhen [layoutObject]="element.button" [model]="model" [specFields]="specFields">
          @if (!element.button.cfgHidden) {
            <lm-button
                    #Element
                    [layoutObject]="element.button"
                    [layoutInfo]="layoutInfo"
                    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                    [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                    [specFields]="specFields"
                    [model]="model"
                    [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                    (fieldEvent)="onFieldEvent($event)"
                    class="field"
            ></lm-button>
          }
        </ng-template>
      }

      @case (layoutSubType.FIELD) {
        <ng-template visiblewhen [layoutObject]="element.field" [model]="model" [specFields]="specFields">
          @if (!element.field.cfgHidden) {
            <lm-field
                      #Element
                      [layoutObject]="element.field"
                      [layoutInfo]="layoutInfo"
                      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                      [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                      [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                      [specFields]="specFields"
                      [placeHolder]="placeHolder"
                      [model]="model"
                      [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                      (fieldEvent)="onFieldEvent($event)"
                      (errorOnMemberField)="onMemberFieldError($event)"
                      class="field"
            ></lm-field>
          }
        </ng-template>
      }

      @case (layoutSubType.TEXT) {
        <ng-template visiblewhen [layoutObject]="element.text" [model]="model" [specFields]="specFields">
          <lm-text
                  #Element
                  [layoutObject]="element.text"
                  [specFields]="specFields"
                  [placeHolder]="placeHolder"
                  [model]="model"
                  [layoutInfo]="layoutInfo"
                  [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                  [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
                  [parentCompoundFieldDisplayOnly]="parentCompoundFieldDisplayOnly"
                  [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                  (fieldEvent)="onFieldEvent($event)"
                  (errorOnMemberField)="onMemberFieldError($event)"
          ></lm-text>
        </ng-template>
      }

      @case (layoutSubType.MENU) {
        <ng-template visiblewhen [layoutObject]="element.menu" [model]="model" [specFields]="specFields">
            <lm-simple-card
                [automationId]="element.menu.automationId"
                [type]="element.menu.type"
                [specFields]="specFields"
                [model]="model"
                [scale]="element.menu.menuScale"
                [link]="element.menu.link"
                [showBackground]="false"
                [imageUrl] = "element.menu.image"
                [title]="element.menu.label"
                [description]="element.menu.description"
                [paragraphLayout]="true"
                [isLink]="element.menu.isLink"
                [isExternalLink]="element.menu.external"
                [allowScannableSearch]="element.menu.allowScannableSearch"
                [openWhenSingleResult]="element.menu.openWhenSingleResult"
                class="field"
                [ngClass]="{'last-member-element': last, 'first-member-element': first}"
                (fieldEvent)="onFieldEvent($event)"
            ></lm-simple-card>
        </ng-template>
      }

      @case (layoutSubType.MANUAL_REPRESENTATION) {
       <lm-manual-representation style="width:100%"
            [manualRep]="element.manualrep"
            class="{{element.class}}"
            [model]="model"
           (fieldEvent)="onFieldEvent($event)"
        ></lm-manual-representation>
      }
    }
  </ng-template>
</div>
